import React from 'react';
import storiesIcon from '../assets/images/Cuentos.svg';
import puppetsIcon from '../assets/images/stories-puppets.svg';
import songsIcon from '../assets/images/songs.svg';
import poemsIcon from '../assets/images/poetry.svg';
import meetIcon from '../assets/images/Conozcamos.svg';
import craftsIcon from '../assets/images/Manualidades.svg';
import workshopsIcon from '../assets/images/Talleres.svg';
import gamesIcon from '../assets/images/Juegos.svg';
import othersIcon from '../assets/images/Otros.svg';
import lockIcon from '../assets/images/lock-play.svg';
import playIcon from '../assets/images/play.svg';
import { isAllowedToPlayVideo } from '../utils/authUtils';

const icons = {
  story: storiesIcon,
  puppet: puppetsIcon,
  song: songsIcon,
  poem: poemsIcon,
  meet: meetIcon,
  craft: craftsIcon,
  workshop: workshopsIcon,
  game: gamesIcon,
  other: othersIcon,
}

const getName = (experience, seasons) => {
  //console.log(experience);
  let name = '';
  seasons.map((season)=> {
    if (season._id === experience.season) {
      name = season.name;
    }
  })
  return name;
}

const Experience = (props) => {
  let thumbnail = props.experience.thumbnail;
  if (!thumbnail || thumbnail === '') {
    if (props.experience.isPublic)
      thumbnail = `https://videodelivery.net/${props.experience.videoId}/thumbnails/thumbnail.jpg?time=8s&height=150&width=280`
    else
      thumbnail = '';
  }
  let seasonName = '';
  if (props.seasons) {
    seasonName = getName(props.experience, props.seasons).toLowerCase();
  }
  
  return (
    <div
      class="col-xs-12 col-sm-6 col-lg-4 mb-4"
      onClick={props.onClick}
    >
      <div class="station-item">
        <div class="imagen-item"
          style={{
            backgroundImage: `url(${thumbnail})`
          }}
        >
          {seasonName &&
          <span class="tag-item">
          {seasonName}
          </span>}
          <span
            className="payed-element"
            style={{
              background: `url(${icons[props.experience.experienceType]}) no-repeat center center / 25px 25px rgba(255, 255, 255, 0.8)`,
            }}
          ></span>
          <span
            class="play"
            style={{
              background: `url(${props.experience.isPublic || isAllowedToPlayVideo() ? playIcon : lockIcon}) no-repeat center center / 70px 70px rgba(0, 0, 0, 0)`
            }}
          ></span>
          <span class="completion">
            <span
              class="percentage"
              style={{
                width: `${props.experience.progress ? props.experience.progress.pctComplete * 100 : 0}%`,
              }}
            ></span>
          </span>
        </div>
        <div class="texto-parrafo py-2 px-3">
          <h3 class="headline-3 pt-2">{props.experience.name}</h3>          
          <p class="texto-parrafo__intro mt-1">{props.experience.description}</p>
        </div>
      </div>
    </div>
  );
};

export default Experience;
